import {RequestVehicle, ResolvedVehicle} from '../../../types/api/api';

export function resolvedVehicleToRequestVehicle(
  resolved: ResolvedVehicle | null | undefined
): RequestVehicle | null {
  if (!resolved) {
    return null;
  }
  return {
    make: resolved.make ?? undefined,
    modelFamily: resolved.model ?? undefined,
    vin: resolved.vin ?? undefined,
    firstRegistrationOnYear: resolved.year ?? undefined,
    power: resolved.power ?? undefined,
    transmission: resolved.transmission ?? undefined,
    fuelType: resolved.fuel ?? undefined,
    drive: resolved.drive ?? undefined,
    bodyStyle: resolved.bodyType ?? undefined,
    mileage: resolved.mileage ?? undefined,
    isVatDeductible: resolved.vatDeductible ?? undefined,
    features: resolved.equipment ?? undefined,
  };
}
